import { render, staticRenderFns } from "./WalletTransferModal.vue?vue&type=template&id=a20c5ec6"
import script from "./WalletTransferModal.vue?vue&type=script&lang=js"
export * from "./WalletTransferModal.vue?vue&type=script&lang=js"
import style0 from "./WalletTransferModal.vue?vue&type=style&index=0&id=a20c5ec6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports